import React, { useState, useEffect, useRef } from "react";
import { Card } from "@aws-amplify/ui-react";
import { BiSearch } from "react-icons/bi";
import "./History.css";
import HistoryTable from "../../components/HistoryTable"
import { useAuth0 } from "@auth0/auth0-react";
import { getChatHistoryApi } from "../../services/AxiosServices";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../context/DataContext";

const History = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { user, getAccessTokenSilently } = useAuth0();
  const username = (user?.preferred_username) || "Moonjelly User";
  const isFetching = useRef(false);
  const [chatHistoryData, setChatHistoryData] = useState<any>([]);
  const navigate = useNavigate();
  const { updateState } = useMyContext();

  const handleChatClick = (threadId: string) => {
    updateState("chatHistorythreadId", threadId);
    navigate("/chat");
  };

const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInMs = now.getTime() - date.getTime();
        const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        if (diffInMinutes < 60) {
            return `${diffInMinutes}m ago`;
        } else if (diffInHours < 24) {
            return `${diffInHours}h ago`;
        } else if (diffInDays === 1) {
            return 'Yesterday';
        } else if (diffInDays < 7) {
            return `${diffInDays}d ago`;
        } else {
            return `${Math.floor(diffInDays / 7)} week${Math.floor(diffInDays / 7) > 1 ? 's' : ''} ago`;
        }
    };

  const fetchChatHistory = async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    try {
      const token = await getAccessTokenSilently();
     const response = await getChatHistoryApi(
        username, token
      );

      if (Array.isArray(response)) {
        setChatHistoryData((prevData) => [...prevData, ...response]);
      } else {
        console.error("Response is not an array:", response);
      }
    } catch (error) {
      console.error("Error fetching chat history: ", error);
    } finally {
      isFetching.current = false;
    }
  };


  useEffect(() => {
    fetchChatHistory();
  }, [username]);


  return (
    <div className="history-container">
      <h1>History</h1>

      <div className="history-layout">
        <div className="left-column">
          <HistoryTable isAIHubPage={false} />
        </div>

        {/* Right Column - Chats */}
        <div className="right-column">
          <Card className="chats-section">
            <div className="chats-header">
              <div className="search-container">
                <h2>Chats</h2>
                <div className="chat-input-wrapper">
                  <BiSearch className="search-icon" />
                  <input
                    type="text"
                    placeholder="search chats"
                    className="chat-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="chats-list">
              {chatHistoryData
                .filter(chat =>
                  chat.message.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((chat) => (
                  <div key={chat.conversation_message_id} className="grid-row" onClick={() => handleChatClick(chat.conversation_thread_id)} style={{ cursor: 'pointer' }}>
                    <div className="chat-name">{chat.message}</div>
                    <div className="grid-action">
                      <div className="chat-time">{formatDate(chat.timestamp)}</div>
                    </div>

                  </div>
                ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default History;
